<form [formGroup]="searchForm"
      class="inset-input-group">
  <input class="form-control form-control-sm rounded-pill" style="height29px;border:unset;outline: none;"
         formControlName="searchString"
         type="text"
         (keyup)="onSubmitSearchForm()"
         [maxlength]="REQS.maxLength.standard"
         [placeholder]="placeholder"/>
  <ng-container *ngIf="searchForm.get('searchString').value">
    <button class="app-btn-danger rounded-circle inset-btn" style="border-radius: 0!important;outline: none;"
            type="button"
            (click)="onClearSearchForm()">
      <i class="material-icons">close</i>
    </button>
  </ng-container>
  <ng-container *ngIf="!searchForm.get('searchString').value">
    <button class="app-btn-success rounded-circle inset-btn"
            style="border-radius: 0!important;outline: none;cursor:default"
            type="submit">
      <i class="material-icons">search</i>
    </button>
  </ng-container>
</form>
